/**
 * Legacy cleanup for the old public eligibility funnel.
 *
 * The public /eligibility page used to collect personal details from anonymous
 * visitors and stash the whole form (name, email, phone, date of birth) in
 * localStorage across a redirect to sign-up. That page is now a profile-free
 * academic-data test: nothing is collected, nothing is stored, and no code
 * writes this key any more.
 *
 * This purge remains so the personal data written by earlier builds is cleared
 * from returning visitors' browsers rather than lingering indefinitely. It can
 * be deleted once enough time has passed for active users to have cycled
 * through at least one session.
 */
const KEY = "studentFormData";

export const clearPendingEligibilityForm = () => {
  try {
    localStorage.removeItem(KEY);
    sessionStorage.removeItem(KEY);
  } catch {
    // Storage unreachable (private mode, blocked site data) — nothing to purge.
  }
};
